module.exports = __webpack_public_path__ + "30ec5f22e9bb6ca4bb5b8fa2cb9727fd.svg";